/**
 * @description: API接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */

export default {
	// 初始化转盘接口
	INIT_TURNTABLE_API: '/turntable/get_turntable_info',
	// 打开幸运转盘宝箱接口
	OPEN_FORTUNE_CHEST_API: '/turntable/open_box',
	// 转盘抽奖接口
	GET_TURNTABLE_REWARD_API: '/turntable/getTurntableReward',
	// 转盘记录拉取视频接口
	MARK_PULL_VIDEO_API: '/turntable/markDoVideo',
	// 挂件转盘 -- 获取挂件仓库
	GET_TURNTABLE_PENDANT_API: '/pendant/GetTurntable3Pendant',
	// 取消装扮当前挂件
	UNINSTALL_PENDANT_API: '/pendant/uninstallPendant',
	// 按ID和天数装扮挂件
	INSTALL_PENDANT_BY_DAY_API: 'pendant/installPendantByIdDay',
	// 获取古诗词频道分类列表接口
	GET_POEM_CATEGORY_API: '/Poems/CategoryList',
	// 获取古诗词频道推荐列表接口
	GET_POEM_RECOMMEND_API: '/Poems/RecommendList',
	// 获取古诗词频道喜欢列表接口
	GET_POEM_Like_API: '/Poems/LikeList',
	// 古诗词频道根据分类id获取分类列表接口
	GET_POEM_LIST_BY_ID_API: '/Poems/ListByCategoryId',
	// 古诗词频道点赞接口
	DO_LIKE_POEM_API: '/Poems/DoLike',
	// 古诗词频道取消点赞接口
	DIS_LIKE_POEM_API: '/Poems/DisLike',
	// 实物奖励 - 获取信息
	GET_COMMODITY_PAGE_INFO: '/commodityReward/getPageInfo',
	// 实物奖励 - 保存用户信息
	COMMODITY_SAVE_USER_ADDRESS: '/CommodityReward/SaveUserAddress',
	// 实物奖励--结束任务
	COMMODITY_FINISH_TASK: '/CommodityReward/FinishTask',
	// 实物奖励--开始任务
	COMMODITY_START_TASK: '/CommodityReward/StartTask',
	// 看资讯赚钱
	NEWS_GET_PAGE_INFO: '/ViewNews/GetPageInfo',
	// 任务开始
	NEWS_MARK_TASK_BEGIN: '/ViewNews/MarkTaskBegin',
	// 标记任务完成
	NEWS_MARK_TASK_COMMIT: '/ViewNews/MarkTaskCommit',
	// 标记任务完成
	NEWS_MARK_TASK_READ_COUNT: '/ViewNews/MarkTaskReadCount',
	// 领取任务奖励
	NEWS_RECEIVE_TASK_REWARD: '/ViewNews/ReceiveTaskReward',
	// 领取宝箱奖励
	NEWS_RECEIVE_CHEST_REWARD: '/ViewNews/ReceiveChestReward',
	// 老版听歌-获取奖励
	GET_APPRECIATE_MUSIC_REWARD_API: '/appreciate/musiccoin',
	// 老版听歌-或者音乐列表
	GET_MUSIC_LIST_API: '/appreciate/musiclist',
	// 老版听歌-音乐鉴赏接口
	CHOOSE_LIKE_SONG_API: '/appreciate/musichabit',
	// 任务征集-任务详情
	GET_COLLECT_SHOW_API: '/Collect/CollectShow',
	// 任务征集-我发布的任务
	GET_COLLECT_MY_LIST_API: '/Collect/MyList',
	// 任务征集-任务大厅
	GET_COLLECT_LIST_API: '/Collect/CollectList',
	// 任务征集-我参与的
	GET_COLLECT_MY_SUBMIT_API: '/Collect/MySubmit',
	// 音乐人认证-获取音乐人标准
	GET_MUSICIAN_STANDARD_API: '/musician/standard',
	// 音乐人认证-是否认证
	GET_MUSICIAN_AUTH_API: '/musician/authMusician',
	// 音乐人认证-加入音乐人
	BECOME_MUSICIAN_API: '/musician/becomeMusician',
	// 抽奖-获取抽奖信息
	GET_TURNTABLE_INFO_API: '/turntable/getTurntableInfo',
	// 活动规则弹窗-获取活动详情
	GET_ACTIVITY_RULE_API: '/activity/get_activity_info',
	// 手动模版h5-获取 h5 模版
	GET_PLAT_H5_API: '/Activity/GetPlatH5',
	// 活动模版v2-获取活动信息
	GET_ACTIVITY_PAGE_V2_API: '/activity/getActivityPage',
	// 活动模版v2-活动报名接口
	GET_ACTIVITY_V2_ENROLL_API: '/activity/enroll',
	// 活动模版v2-获取活动分享信息
	GET_ACTIVITY_V2_SHARE_INFO: '/activity/getUserLastLoginMethod',
	// 活动模版v3-获取活动信息
	GET_ACTIVITY_PAGE_V3_API: '/ActivityTemplate/getActivityPage',
	// 活动模板v3-裂变分享活动完成任务
	SHARE_TASK_TRACK: '/ActivityTemplate/ShareTaskTrack',
	// v3活动抽奖
	GET_ACTIVITY_LuckDraw_V3_API: '/ActivityTemplate/LuckDraw',
	// 活动模版v3-执行任务接口
	ACTIVITY_PROCESS_TASK_V3_API: '/ActivityTemplate/ProcessTask',
	// 活动模版v3-关注任务接口
	ACTIVITY_FOLLOW_USER_V3_API: '/ActivityTemplate/FollowUser',
	// 活动模版v3-领取奖励接口
	ACTIVITY_RECEIVE_REWARD_V3_API: '/ActivityTemplate/ReceiveReward',
	// 用户历史收获地址
	ACTIVITY_GET_USER_ADDR_V3_API: '/ActivityTemplate/GetUserAddress',
	// 获取奖励列表
	ACTIVITY_GET_AWARD_LIST_V3_API: '/ActivityTemplate/AwardList',
	// 实物奖励保存用户信息
	ACTIVITY_SAVE_AWARD_INFO_V3_API: '/ActivityTemplate/SaveAwardInfo',
	// 余额兑换金币
	BALANCE_CONVERT_COIN: '/ActivityTemplate/BalanceConvertCoin',
	// 抽奖排行榜
	GET_DRAW_RANK_LIST: 'ActivityTemplate/GetDrawRankList',
	// 裂变分享排行榜
	GET_TASK_RANK_LIST: 'ActivityTemplate/GetTaskRankList',
	// weekly 活动-获取页面数据
	GET_WEEKLY_PAGE_INFO: '/contribution/page_info',
	// 边学变赚钱-获取任务信息
	GET_LEARN_TASK_LIST_API: '/LearnGraphic/TaskList',
	// 边学变赚钱-分享获取奖励接口
	GET_SHARE_REWARD_API: '/LearnGraphic/shareReward',
	// 天天拆红包-获取红包列表
	GET_OPEN_ENVELOPES_LIST_API: '/OpenEnvelopesDay/EnvelopesDetail',
	// 天天拆红包-开启普通红包
	OPEN_NORMAL_ENVELOPE_API: '/OpenEnvelopesDay/EnvelopesNormalOpen',
	// 天天拆红包-开启大红包
	OPEN_BIG_ENVELOPE_API: '/OpenEnvelopesDay/EnvelopesCheck',
	//  挂件列表
	GET_PENDANT_LIST: '/Pendant/GetPendantList',
	//  佩戴挂件
	INSTALL_PENDANT: '/Pendant/InstallPendant',
	//  取消佩戴
	UNINSTALL_PENDANT: '/Pendant/UninstallPendant',
	// 兑换商城挂件
	CONVERT_PENDANT: '/Pendant/ConvertPendant',
	// 双人打卡-活动页面数据接口
	GET_DOUBLE_SIGN_PAGE_API: '/DoubleSign/GetPageInfo',
	// 双人打卡-签到接口
	SIGN_IN_DOUBLE_API: '/DoubleSign/SignIn',
	// 双人打卡-领取打卡奖励
	GET_DOUBLE_SIGN_REWARD_API: '/DoubleSign/GetReward',
	// 元旦砸金蛋-获取砸金蛋活动数据
	GET_SMASHING_PAGE_INFO_API: '/GoldenEggs/GetTaskProgressInfo',
	// 元旦砸金蛋-开启金蛋接口
	OPEN_EGG_API: '/GoldenEggs/BreakGoldenEggs',
	// 投稿活动-获取排行榜数据(投稿量)
	GET_CONTRIBUTE_RANK_LIST_API: '/Activity/GetContributeUserRank',
	// 投稿活动-获取排行榜数据(播放量)
	GET_CONTRIBUTE_RANK_PLAY_API: '/Activity/GetTopicMusicPlayRank',
	// 投稿活动-获取排行榜数据(点赞量)
	GET_CONTRIBUTE_RANK_LIKE_API: '/Activity/GetTopicMusicLikeRank',
	// 投稿活动-获取最新投稿
	GET_HQ_CONTRIBUTE_LAST_LIST_API: '/Activity/GetHQContributeList',
	// 投稿活动-获取最新投稿
	GET_CONTRIBUTE_LAST_LIST_API: '/Activity/GetContributeList',
	// 活动大放送页面
	// GET_ACTIVITY_LIST: '/Activity/GetBroadcastList',
	GET_ACTIVITY_LIST: '/Activity/GetBroadcastListV2',
	// 中秋活动信息
	GET_MID_AUTUMN_PAGE_INFO: '/MidAutumn/TaskInfo',
	// 更新中秋活动进度
	UPDATE_MID_AUTUMN_TASK: '/MidAutumn/TaskProgress',
	// 国庆活动信息
	GET_NATIONAL_DAY_PAGE_INFO: '/NationalDay/ProvinceList',
	// 国庆省份活动信息
	GET_NATIONAL_DAY_PROVINCE_INFO: '/NationalDay/ProvinceInfo',
	// 国庆活动弹幕列表
	GET_NATIONAL_DAY_COMMENT_LIST: '/NationalDay/CommentList',
	// 国庆活动发布作品标记
	MARK_NATIONAL_DAY_TASK: '/NationalDay/PostMark',
	// 国庆活动做任务
	TAKE_NATIONAL_DAY_TASK: '/NationalDay/TaskProgress',
	// 2022年度报告
	ACTIVITY_ANNUAL_REPORT: '/AnnualReport/GetPageData',
	// 2023年度报告
	ACTIVITY_ANNUAL_REPORT2023: '/AnnualReport/GetPageData2023',
	// 盲盒已读上报
	ACTIVITY_ANNUAL_REPORT2023_ReadBlindBox: '/AnnualReport/ReadBlindBox',
	// 盲盒列表获取
	GET_BLIND_BOX_LIST: '/ActivityTemplate/GetBlindBoxList',
	// 获取现金抽奖支付方式
	GET_PAY_CHANNEL: '/ActivityTemplate/GetPaymentChannel',
	// 现金抽奖下单
	CREATE_ORDER: '/ActivityTemplate/CreateUnifiedOrder',
	// 现金抽奖订单查询
	ORDER_QUERY: '/ActivityTemplate/OrderQuery',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/activity.js